import { useContext } from "react";
import { UserContext } from "./UserProvider";

const useAuth = () => {
  return useContext(UserContext);
};

export default useAuth;
